import { privacyConstants, uriConstants } from '../../constants'
import { defaultService } from '../../services'
import { errorMessages } from '../../messages'
import { alertActions } from '../'

export const essentialPrivacyActions = {
    load,
}

/**
 * 로딩
 */

function load(params) {
    return async (dispatch) => {
        dispatch(apiAction(privacyConstants.LOAD_REQUEST))

        const queryString = require('query-string')
        let paramStr = queryString.stringify(params)
        paramStr.length > 0 && (paramStr = '?' + paramStr)

        defaultService
            .handleService({
                method: 'get',
                endPoint: uriConstants.API_URI + uriConstants.GET_ESSENTIAL_PRIVACY + paramStr,
            })
            .then(
                (response) => {
                    dispatch(apiAction(privacyConstants.LOAD_SUCCESS, response))
                },
                (error) => {
                    dispatch(apiAction(privacyConstants.LOAD_FAILURE, error))
                    dispatch(apiError(error))
                },
            )
    }
}

/**
 * API 액션 함수
 */
function apiAction(type, response = null) {
    let resultObj = { type }
    response && (resultObj.response = response)
    // console.log(resultObj)
    return resultObj
}

/**
 * API 통신 에러 문구 공통처리
 */
function apiError(error) {
    return alertActions.error({
        title: null,
        message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
    })
}
